export const deliveries = state => state.deliveries
export const countStatus = state => state.countStatus
export const deliverySelected = state => state.deliverySelected
export const saveTabSelected = state => state.saveTabSelected
export const partnerErrorCount = state => state.partnerErrorCount
export const driverDeliveryCounters = state => {
    return {
        openDeliveries: state.driverDeliveryCounters.openDeliveries || 0,
        closedDeliveries: state.driverDeliveryCounters.closedDeliveries || 0,
        openPickups: state.driverDeliveryCounters.openPickups || 0,
        closedPickups: state.driverDeliveryCounters.closedPickups || 0,
        totalDeliveries: (state.driverDeliveryCounters.openDeliveries || 0) + (state.driverDeliveryCounters.closedDeliveries || 0),
        totalPickups: (state.driverDeliveryCounters.openPickups || 0) + (state.driverDeliveryCounters.closedPickups || 0)
    }
}

